/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BellZ(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M220.81445,175.93945C214.87988,165.72363,207.80469,146.33789,207.80469,112v-7.0957c0-44.28516-35.52735-80.57813-79.19629-80.90235-.2041-.001-.40625-.002-.61035-.002a79.89888,79.89888,0,0,0-79.79492,80v8c0,34.33594-7.07911,53.7207-13.01661,63.93555A15.99886,15.99886,0,0,0,48.9834,200H88a40,40,0,0,0,80,0h39.0166a15.99808,15.99808,0,0,0,13.79785-24.06055ZM128,224a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224Zm20-72H108a7.99925,7.99925,0,0,1-6.14551-13.12109L130.91992,104H108a8,8,0,0,1,0-16h40a7.99925,7.99925,0,0,1,6.14551,13.12109L125.08008,136H148a8,8,0,0,1,0,16Z" />
    </Svg>
  );
}

export default BellZ;
